module.exports = __webpack_public_path__ + "static/media/02.Wtih Puppet.52257a2c.jpg";